import jwLoadImg from './jw-load-img'
// eslint-disable-next-line func-names
const install = function (Vue) {
  Vue.directive('jw-load-img', jwLoadImg)
}

if (window.Vue) {
  window['jw-load-img'] = jwLoadImg
  Vue.use(install) // eslint-disable-line
}

jwLoadImg.install = install
export default jwLoadImg
